var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { variables } from '../../styles/variables';
import { LoadingOutlined } from '@ant-design/icons';
// Komponent ikony symulującej ładowanie z zaiplementowanymi stylami (w tym style dla właściwości własnej)
var LoaderStyled = styled(LoadingOutlined)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n  font-size: ", ";\n  color: ", ";\n"], ["\n  margin: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (props) { return props.format === 'large' ? '140px auto' : '0'; }, function (props) { return props.format === 'large' ? '5rem' : '2rem'; }, variables.colorDecorator);
export { LoaderStyled as Loader };
var templateObject_1;
